export default __webpack_public_path__ + "static/cabin-tiny-home-2-queens-3-77fbe88bbe4dd908b3aea716dd2eb5bf.jpg";